import { Tier } from './tier';
import { Flavor } from './flavor';
import { Sale } from './sale';
import { Award } from './award';

export class Product {
    name: String = '';
    image: String = '';
    ibu: Number = 0;
    abv: Number = 0;
    limit: Number = 0;
    brewer:String = '';
    srm: Number = 1;
    awards: Object = {'a': new Award};
    tiers: Object = {'a' : new Tier};
    sale: Sale = new Sale;
    flavors: Object = {'a': new Flavor}; 
}



// WEBPACK FOOTER //
// ./src/app/product.ts